// QR Kiosk v2 — Report-a-fault XL action (designer `XLAction`). Kiosk-legibility
// rework 2026-07-23 (KV2_DESIGN_REVIEW_FEEDBACK.md §1): the Open-reports row moved
// into DashboardTileGrid as a uniform tile; this file now owns ONLY the fault CTA.
// WIDTH BUG FIX: a <button> is a form control — its `width: auto` is shrink-to-fit
// even as a block-level flex container, so the old bar hugged its content (the
// owner's "not full width" + "icon at the left edge" complaint). Explicit
// width: calc(100% - 28px) pins it to the column minus the 14px gutters. Tokens only.
import React from "react";
import { useNavigate } from "react-router-dom";
import { Machine } from "../../models/machinesModels";
import useTranslation from "../../../shared/hooks/useTranslation";
import { Glyph, GD } from "../shared/glyphs";
import { usePressed } from "../shared/usePressed";

export interface DashboardActionRowsProps {
  machine: Machine;
}

export function DashboardActionRows({ machine }: DashboardActionRowsProps) {
  const navigate = useNavigate();
  const { translate } = useTranslation("public");
  const fault = usePressed();

  // §3.5 nav guard — never emit /public-v2/machines/undefined/…
  const go = (path: string) => {
    if (machine?.internalNumber) navigate(path);
  };

  return (
    <button
      type="button"
      {...fault.pressHandlers}
      onClick={() => go(`/public-v2/service-reports/create?machine=${machine.internalNumber}`)}
      style={{
        margin: "12px 14px 0",
        width: "calc(100% - 28px)",
        flexShrink: 0,
        height: 64,
        borderRadius: 14,
        border: "1px solid color-mix(in oklab, var(--red) 50%, var(--border))",
        background: "color-mix(in oklab, var(--red) 13%, var(--card))",
        color: "color-mix(in oklab, var(--red) 88%, var(--ink))",
        fontFamily: "inherit",
        fontSize: 18,
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        cursor: "pointer",
        ...fault.pressStyle,
      }}
    >
      <Glyph d={GD.warn} size={32} />
      {translate("kioskReportFault")}
    </button>
  );
}

export default DashboardActionRows;
